import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Sentry } from './sentry';

interface Props {
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// Dependency-free boundary: keeps @sentry/react off the eager import graph.
// Renders `fallback` immediately on error and forwards the error to the lazy
// Sentry facade (which buffers until @sentry/react finishes loading).
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render(): ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
